import { render } from "./PanelForm.vue?vue&type=template&id=3275fb1c&scoped=true"
import script from "./PanelForm.vue?vue&type=script&lang=js"
export * from "./PanelForm.vue?vue&type=script&lang=js"

import "./PanelForm.vue?vue&type=style&index=0&id=3275fb1c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3275fb1c"]])

export default __exports__